// extracted by mini-css-extract-plugin
export default {"form":"form___FOtGg","logo":"logo___hDLnV","header":"header___PHvQe","links":"links___jAy4p"};